import { isFilledValue } from "web_myplann/Shared/Utils/isFilledValue";

export const hasAnyDetailValue = (
	...values: (string | number | null | undefined)[]
) => values.some(isFilledValue);
